export const SET_BOOKING_QUERY_STRING_PARAMS = 'SET_BOOKING_QUERY_STRING_PARAMS';
export const SET_BOOKING_ITEM = 'SET_BOOKING_ITEM';
export const SET_HOTEL_INFO = 'SET_HOTEL_INFO';
export const SET_ROOM_INFO = 'SET_ROOM_INFO';
export const SET_USER_INFO = 'SET_USER_INFO';